import { Address } from './organisation-address.model';
import { OrganisationSMTPSettings } from './organisation-smtp-settings.model';

import { environment } from '@env';

export class Organisation {
    id: number = -1;
    name: string = '';
    companyNumber = '';
    subjectToVat: boolean = false;
    countryCode = '';
    email?: string | null;
    address?: Address;
    smtpSettings?: OrganisationSMTPSettings | null;
    mailConnection?: number;
    connectionActionRequired = false;
    notificationContentNl = '';
    notificationContentDe = '';
    notificationContentFr = '';
    notificationContentEn = '';
    avatarUrl = '';
    updateAvatar?: File;
    mailColor?: string | null;
    subscriptionTags: string[] = [];
    phoneNumber?: string;

    serialize(): any {
        return {
            id: this.id,
            name: this.name,
            company_number: this.companyNumber,
            subject_to_vat: this.subjectToVat,
            country_code: this.countryCode,
            phone_number: this.phoneNumber,
            email: this.email,
            address: this.address?.serialize(),
            mail_connection: this.mailConnection,
            smtp_settings: this.smtpSettings?.serialize() ?? null,
            connection_action_required: this.connectionActionRequired,
            notification_content_nl: this.notificationContentNl,
            notification_content_de: this.notificationContentDe,
            notification_content_fr: this.notificationContentFr,
            notification_content_en: this.notificationContentEn,
            avatar: this.updateAvatar,
            mail_header_color: this.mailColor,
            subscriptionTags: this.subscriptionTags,
        };
    }

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.name = data.name ?? '';
        this.companyNumber = data.company_number ?? '';
        this.subjectToVat = data.subject_to_vat ?? false;
        this.countryCode = data.country_code ?? '';
        this.phoneNumber = data.phone_number ?? undefined;
        this.email = data.email ?? undefined;
        this.address = data.address ? new Address().deserialize(data.address) : undefined;
        this.smtpSettings = data.smtp_settings ? new OrganisationSMTPSettings().deserialize(data.smtp_settings) : undefined;
        this.mailConnection = data.mail_connection ?? undefined;
        this.connectionActionRequired = data.connection_action_required ?? false;
        this.notificationContentNl = data.notification_content_nl;
        this.notificationContentDe = data.notification_content_de;
        this.notificationContentFr = data.notification_content_fr;
        this.notificationContentEn = data.notification_content_en;
        this.avatarUrl = data.avatar;
        this.updateAvatar = data.update_avatar ?? undefined;
        this.mailColor = data.mail_header_color ?? environment.defaultMailColor;
        this.subscriptionTags = data.subscription_tags ?? [];
        return this;
    }

    clone(): Organisation {
        let avatar = this.updateAvatar;
        let serializedOrg = this.serialize();
        serializedOrg.update_avatar = avatar;
        serializedOrg.avatar = this.avatarUrl;
        return new Organisation().deserialize(serializedOrg);
    }
}
